type SrNotificationResponse {
  message: String
}

input SrNotificationInput {
  case_id: String
  client_email_address: String!
  client_first_name: String!
  client_id: String!
  org_name: String!
  subject: String!
  user_first_name: String!
  user_last_name: String
}
